import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'

const SharedPresentationReducer = combineReducers({
  fetchRequest: createRequestReducer('SHARED_PRESENTATION:FETCH'),
  copyRequest: createRequestReducer('SHARED_PRESENTATION:COPY'),
  sharedPresentation: createReducer(null, {
    'SHARED_PRESENTATION:FETCH_REQUEST': state => null,
    'SHARED_PRESENTATION:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      response.data.shared_presentation
  })
})

export default SharedPresentationReducer
